<template>
  <div :class="`${props.pagecontent}`" v-html="markup" />
</template>

<script setup>
import { ref, watch, onMounted, onBeforeUnmount } from 'vue';
import less from 'less';
import MarkdownIt from 'markdown-it';
import { API_BASE, MARKDOWN_CONFIG, PUBLICATION_STATE } from '../constants.js';

const props = defineProps({
  pagecontent: {
    type: String,
    default: '',
    required: true,
  },
});

const markup = ref('');
const markdown = new MarkdownIt(MARKDOWN_CONFIG);
const styleEl = document.createElement('style');

onMounted(() => {
  document.head.appendChild(styleEl);
});

onBeforeUnmount(() => {
  document.head.removeChild(styleEl);
});

watch(
  () => props.pagecontent,
  async (value) => {
    markup.value = '';
    const response = await fetch(
      `${API_BASE}/${value}?publicationState=${PUBLICATION_STATE}`
    );
    const data = await response.json();
    if (!data.data.attributes.style) {
      styleEl.innerHTML = '';
    } else {
      try {
        const style = await less.render(
          `.${props.pagecontent} {
            ${data.data.attributes.style}
          }`
        );
        styleEl.innerHTML = style.css;
      } catch (e) {
        styleEl.innerHTML = '';
        console.error(e); // eslint-disable-line no-console
      }
    }
    markup.value = markdown.render(data.data.attributes.Inhalt);
  },
  { immediate: true }
);
</script>
